import { Box, Tooltip } from '@mui/material'
import { CustomColumnGridConfig } from '../types'
import EmailIcon from '../../../../../assets/chanellsIcons/EmailIcon.svg'
import WhatsappIcon from '../../../../../assets/chanellsIcons/WhatsappIcon.svg'
import SmsIcon from '../../../../../assets/chanellsIcons/SmsIcon.svg'
import FileIcon from '../../../../../assets/chanellsIcons/File.svg'
import dayjs from 'dayjs'
const iconMap: Record<string, string> = {
  EmailIcon,
  WhatsappIcon,
  SmsIcon,
  FileIcon,
}
const columnsConfig: CustomColumnGridConfig[] = [
  {
    width: 150,
    minWidth: 150,
    field: 'alertType',
    headerName: 'סוג התראה',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'severity',
    headerName: 'רמת חומרה',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    minWidth: 150,
    field: 'waterCard',
    headerName: 'מספר כ.מים',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'meterId',
    headerName: 'מספר מד',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'consumerName',
    headerName: 'שם צרכן',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'payerNumber',
    headerName: 'מספר משלם',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'address',
    headerName: 'כתובת',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    minWidth: 150,
    field: 'capacity',
    headerName: 'ק.אחרונה',
    filterSpec: { kind: 'number' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'lastSeen',
    headerName: 'ת.ק.אחרונה',
    filterSpec: { kind: 'date' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'fromDate',
    headerName: 'מועד התראה',
    filterSpec: { kind: 'date' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
    renderCell: (params: any) => {
      return params.value ? dayjs(params.value).format('DD/MM/YYYY') : '-'
    },
  },

  {
    flex: 1,
    width: 150,
    minWidth: 150,
    field: 'isOpen',
    headerName: 'סטטוס',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
    renderCell: (params: any) => {
      return params.value ? 'פתוח' : 'סגור'
    },
  },

  // Actions with icons (WhatsApp / Email / SMS, etc.)
  // You can render this with a custom cell renderer in your DataGrid component.
  {
    width: 150,
    minWidth: 150,
    field: 'messages',
    headerName: 'פעולות שננקטו',
    filterSpec: { kind: 'none' },
    filterable: false,
    hideable: true,
    disableAggregation: true,
    renderCell: (params: any) => {
      const channels: Array<{
        channel: string
        icon: string
      }> = params.row?.sentChannels ?? []
      if (channels.length)
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              justifyContent: 'center',
              width: '100%',
            }}
          >
            {channels.map((channelObj, index) => (
              <Tooltip key={index} title={channelObj.channel}>
                <img
                  src={iconMap[channelObj.icon]}
                  alt={channelObj.channel}
                  style={{ width: 18, height: 18 }}
                />
              </Tooltip>
            ))}
          </Box>
        )
      else {
        return <span>-</span>
      }
    },
  },
]

export default columnsConfig
